import { compose, withStateHandlers, withHandlers, lifecycle } from 'recompose'
import isEqual from 'lodash/isEqual'

const withSetFocusRefHandler = withStateHandlers({
  focusScopeRef: null
}, {
  setFocusScopeRef: () => ref => ({ focusScopeRef: ref })
})

const withFocusFirstInput = withHandlers({
  focusFirstInput: ({ focusScopeRef }) => () => {
    const firstInput = focusScopeRef && focusScopeRef.querySelector && focusScopeRef.querySelector('input')
    firstInput && firstInput.focus && firstInput.focus()
  }
})

const withLifecycle = lifecycle({
  componentDidUpdate({ focusScopeRef: prevFocusRef }) {
    const { focusFirstInput, focusScopeRef } = this.props
    focusScopeRef && !isEqual(focusScopeRef, prevFocusRef) && focusFirstInput()
  }
})

export default compose(
  withSetFocusRefHandler,
  withFocusFirstInput,
  withLifecycle
)
